import { render, staticRenderFns } from "./LocationSelect.vue?vue&type=template&id=506f1dc4&"
import script from "./LocationSelect.vue?vue&type=script&lang=js&"
export * from "./LocationSelect.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports